import React from 'react';
import {
  ModalDialog,
  ModalDialogBody,
  ModalDialogButtons,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogNav,
  ModalDialogFooter,
  Button,
  Typography,
  Link,
  GridContainer,
  Row,
  Column,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@vp/swan';

import { useTranslations } from '@vp/om-translations';

import PropTypes from 'prop-types';

export const ConfirmationModal = ({
  linkText,
  prompt,
  cancelText,
  confirmText,
  action,
  visuallyHiddenModalDialogLabel,
  linkTextDescribedBy,
  linkClickCallback,
  cancelBtnCallback,
}) => {
  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  const [sharedActionMessages] = useTranslations(['sharedActionMessages']);

  const columnSpan = cancelText && confirmText && action ? 6 : 12;

  return (
    <>
      <ModalDialog
        isOpen={modalIsOpen}
        onRequestDismiss={() => setModalIsOpen(false)}
        variant="standard"
      >
        <ModalDialogContent>
          <ModalDialogHeader visuallyHidden>
            <ModalDialogTitle id="confirmation-dialog-heading">
              {visuallyHiddenModalDialogLabel}
            </ModalDialogTitle>
          </ModalDialogHeader>
          <ModalDialogNav>
            <ModalDialogCloseButton
              visuallyHiddenLabel={sharedActionMessages.close}
            />
          </ModalDialogNav>
          <ModalDialogBody aria-labelledby="confirmation-dialog-heading">
            <Typography>{prompt}</Typography>
          </ModalDialogBody>
          <ModalDialogFooter>
            <ModalDialogButtons>
              <GridContainer>
                <Row>
                  {cancelText ? (
                    <Column span={columnSpan}>
                      <Button
                        size="mini"
                        width="full-width"
                        skin="secondary"
                        marginBottom={1}
                        onClick={() => {
                          setModalIsOpen(false);
                          if (
                            cancelBtnCallback &&
                            typeof cancelBtnCallback === 'function'
                          )
                            cancelBtnCallback();
                        }}
                      >
                        {cancelText}
                      </Button>
                    </Column>
                  ) : undefined}

                  {confirmText && action ? (
                    <Column span={columnSpan}>
                      <Button
                        size="mini"
                        width="full-width"
                        skin="primary"
                        marginBottom={1}
                        onClick={() => {
                          setModalIsOpen(false);
                          action();
                        }}
                      >
                        {confirmText}
                      </Button>
                    </Column>
                  ) : undefined}
                </Row>
              </GridContainer>
            </ModalDialogButtons>
          </ModalDialogFooter>
        </ModalDialogContent>
      </ModalDialog>
      <Link
        render={p => (
          <Button
            skin="link"
            className={p.className}
            onClick={() => {
              setModalIsOpen(true);
              if (linkClickCallback && typeof linkClickCallback === 'function')
                linkClickCallback();
            }}
            aria-describedby={linkTextDescribedBy}
          >
            {p.children}
          </Button>
        )}
      >
        {linkText}
      </Link>
    </>
  );
};

ConfirmationModal.propTypes = {
  linkText: PropTypes.string.isRequired,
  prompt: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  action: PropTypes.func,
  visuallyHiddenModalDialogLabel: PropTypes.element.isRequired,
  linkTextDescribedBy: PropTypes.string,
  linkClickCallback: PropTypes.func,
  cancelBtnCallback: PropTypes.func,
};
